var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"app-navigation-loading-placeholder-entry"},[_c('div',{staticClass:"icon icon-loading"})])
}]

export { render, staticRenderFns }